"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.draw_risk_page = exports.SharedOverviewComponents = exports.LoadingSpinner = exports.prepareOverviewFilter = exports.ControlActionApp = exports.RiskListApp = exports.ObservationsListApp = exports.RiskControlApp = exports.RiskEffectsApp = exports.RiskCausesApp = exports.RiskReferencesApp = exports.ContractGovernanceApp = exports.store = void 0;
var React = require("react");
var react_dom_1 = require("react-dom");
var mobx_react_1 = require("mobx-react");
var attachedControls_1 = require("./components/riskPage/attachedControls");
var controlDialog_1 = require("./components/controls/controlDialog");
var riskAccordion_1 = require("./components/riskPage/riskAccordion");
var governanceContainer_1 = require("./components/contracts/governanceContainer");
var stateFragments_1 = require("./stateFragments");
var api_1 = require("./api");
var contexts_1 = require("./interfaces/contexts");
var mobx_1 = require("mobx");
var remappingApp_1 = require("./components/remap_ownership/remappingApp");
var overviewApp_1 = require("./components/overview/overviewApp");
var viewOptions_1 = require("./components/overview/viewOptions");
var causality_1 = require("./components/riskPage/causality");
var $ = require("jquery");
var responsibilities_1 = require("./components/responsibilities/responsibilities");
var controlActionList_1 = require("./components/editableList/controlActionList");
var riskReviewPanelApp_1 = require("./components/riskPage/riskReviewPanelApp");
var riskCausalityList_1 = require("./components/editableList/causality/riskCausalityList");
var editableListDialog_1 = require("./components/editableList/editableListDialog");
var projectForm_1 = require("./components/admin/projectForm");
var editCategories_1 = require("./components/admin/editCategories");
var editRiskTargets_1 = require("./components/admin/editRiskTargets");
var observationsList_1 = require("./components/editableList/observationsList");
var urls_1 = require("./urls");
var DataListState_1 = require("./components/dataList/DataListState");
var dataListLoader_1 = require("./components/dataList/dataListLoader");
var LogisticsApp_1 = require("./components/logistics/LogisticsApp");
var SiteMapsAdminApp_1 = require("./components/admin/site_maps/SiteMapsAdminApp");
var AdminAppWrapper_1 = require("./components/admin/AdminAppWrapper");
var ifcExport_1 = require("./components/admin/bim/ifcExport");
var RiskBimMaps_1 = require("./components/riskPage/RiskBimMaps");
var AppState = (function () {
    function AppState() {
        this.me = mobx_1.observable.box(null);
        this.context = mobx_1.observable.box(null);
        this.users = new stateFragments_1.UserListState();
        this.controls = new stateFragments_1.ControlListState();
        this.catags = new stateFragments_1.CatagListState();
        this.ownerships = new stateFragments_1.OwnershipListState();
        this.roles = new stateFragments_1.RoleListState();
        this.contract = new stateFragments_1.ContractState();
        this.riskPage = {
            accordion: new stateFragments_1.RiskAccordionState(),
            riskReview: new stateFragments_1.RiskReviewState(),
        };
        this.causalityDialog = new stateFragments_1.CausalityDialogState();
        this.controlDialog = new stateFragments_1.ControlDialogAppState();
        this.overview = new stateFragments_1.OverviewState();
        this.isProjectAdmin = mobx_1.observable.box(false);
        this.risklist = new stateFragments_1.RiskTableListState();
        this.controllist = new stateFragments_1.ControlTableListState();
        this.actionlist = new stateFragments_1.ActionTableListState();
        this.causalitylist = new stateFragments_1.CausalityTableListState();
        this.responsibility = new stateFragments_1.ResponsibilityListState();
        this.closeAttachedControlsDialog = new stateFragments_1.CloseAttachedControlsDialogState();
        this.editableListDialog = new stateFragments_1.EditableListDialogState();
        this.referenceDialog = new stateFragments_1.ReferenceDialogState();
        this.observationDialog = new stateFragments_1.ObservationDialogState();
        this.observationslist = new DataListState_1.DataListState(urls_1.Urls.observations_list_data);
    }
    AppState.prototype.getMe = function () {
        if (this.me.get() == null) {
            this.fetchMe();
        }
        return this.me.get();
    };
    AppState.prototype.quickAddUser = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = exports.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        project_id = context.project;
                        return [4, api_1.api.projects
                                .id(project_id)
                                .quick_users.post({ quick_name: value })];
                    case 1:
                        user = _a.sent();
                        this.controlDialog.refresh({ only_owners: true });
                        return [2, user];
                    case 2: throw new Error("Cannot quick add a user outside of a project context");
                }
            });
        });
    };
    AppState.prototype.fetchMe = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, api_1.api.users.me().get()];
                    case 1:
                        user = _a.sent();
                        this.me.set(user);
                        return [2, user];
                }
            });
        });
    };
    return AppState;
}());
exports.store = new AppState();
var ContractGovernanceApp = (function (_super) {
    __extends(ContractGovernanceApp, _super);
    function ContractGovernanceApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContractGovernanceApp.prototype.render = function () {
        var contract = exports.store.contract.governance
            ? exports.store.contract.governance.contract
            : null;
        return React.createElement(governanceContainer_1.GovernanceContainer, { contract: contract });
    };
    ContractGovernanceApp = __decorate([
        mobx_react_1.observer
    ], ContractGovernanceApp);
    return ContractGovernanceApp;
}(React.Component));
exports.ContractGovernanceApp = ContractGovernanceApp;
var RiskReferencesApp = (function (_super) {
    __extends(RiskReferencesApp, _super);
    function RiskReferencesApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskReferencesApp.prototype.render = function () {
        var context = exports.store.context.get();
        var risk_id;
        if (context instanceof contexts_1.RiskContext) {
            risk_id = context.risk;
        }
        else {
            throw new Error("Cannot use RiskAccordion outside of RiskContext");
        }
        return React.createElement("div", null,
            React.createElement(riskAccordion_1.RiskReferences, { risk_id: risk_id, references: exports.store.riskPage.accordion.references, elementsToShow: exports.store.riskPage.accordion.elementsToShow }));
    };
    RiskReferencesApp = __decorate([
        mobx_react_1.observer
    ], RiskReferencesApp);
    return RiskReferencesApp;
}(React.Component));
exports.RiskReferencesApp = RiskReferencesApp;
var RiskCausesApp = (function (_super) {
    __extends(RiskCausesApp, _super);
    function RiskCausesApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskCausesApp.prototype.render = function () {
        var context = exports.store.context.get();
        var risk_id;
        if (context instanceof contexts_1.RiskContext) {
            risk_id = context.risk;
        }
        else {
            throw new Error("Cannot use RiskAccordion outside of RiskContext");
        }
        return (React.createElement("div", null,
            React.createElement(causality_1.CausalityDialog, { isCause: exports.store.causalityDialog.isCause, isOpen: exports.store.causalityDialog.isOpen, causality: exports.store.causalityDialog.causality, causeSearchResults: exports.store.causalityDialog.causeSearchResults, effectSearchResults: exports.store.causalityDialog.effectSearchResults, affectedRisks: exports.store.causalityDialog.affectedRisks, isLoadingRisks: exports.store.causalityDialog.isLoadingRisks, isSearchingCausalities: exports.store.causalityDialog.isSearchingCausalities, afterSaveCallback: function () {
                    return exports.store.riskPage.accordion.fetchCausalities();
                } }),
            React.createElement(riskAccordion_1.RiskCauses, { risk_id: risk_id, causes: exports.store.riskPage.accordion.causalities.filter(function (c) { return c.is_cause; }), elementsToShow: exports.store.riskPage.accordion.elementsToShow })));
    };
    RiskCausesApp = __decorate([
        mobx_react_1.observer
    ], RiskCausesApp);
    return RiskCausesApp;
}(React.Component));
exports.RiskCausesApp = RiskCausesApp;
var RiskEffectsApp = (function (_super) {
    __extends(RiskEffectsApp, _super);
    function RiskEffectsApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskEffectsApp.prototype.render = function () {
        var context = exports.store.context.get();
        var risk_id;
        if (context instanceof contexts_1.RiskContext) {
            risk_id = context.risk;
        }
        else {
            throw new Error("Cannot use RiskAccordion outside of RiskContext");
        }
        return (React.createElement("div", null,
            React.createElement(causality_1.CausalityDialog, { isCause: exports.store.causalityDialog.isCause, isOpen: exports.store.causalityDialog.isOpen, causality: exports.store.causalityDialog.causality, causeSearchResults: exports.store.causalityDialog.causeSearchResults, effectSearchResults: exports.store.causalityDialog.effectSearchResults, affectedRisks: exports.store.causalityDialog.affectedRisks, isLoadingRisks: exports.store.causalityDialog.isLoadingRisks, isSearchingCausalities: exports.store.causalityDialog.isSearchingCausalities, afterSaveCallback: function () {
                    return exports.store.riskPage.accordion.fetchCausalities();
                } }),
            React.createElement(riskAccordion_1.RiskEffects, { risk_id: risk_id, effects: exports.store.riskPage.accordion.causalities.filter(function (c) { return !c.is_cause; }), elementsToShow: exports.store.riskPage.accordion.elementsToShow })));
    };
    RiskEffectsApp = __decorate([
        mobx_react_1.observer
    ], RiskEffectsApp);
    return RiskEffectsApp;
}(React.Component));
exports.RiskEffectsApp = RiskEffectsApp;
var RiskControlApp = (function (_super) {
    __extends(RiskControlApp, _super);
    function RiskControlApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskControlApp.prototype.render = function () {
        return (React.createElement("div", { ref: function (div) {
                $("#add_control").off("click");
                $("#add_control").click(function () {
                    if (is_new_risk()) {
                        notify_to_save_risk();
                        return;
                    }
                    exports.store.controlDialog.openDialog(null);
                });
            } },
            React.createElement(controlDialog_1.ControlDialog, { isOpen: exports.store.controlDialog.isOpen, control: exports.store.controlDialog.control, applied_tags: exports.store.controlDialog.applied_tags, available_tags: exports.store.controlDialog.available_tags, isMandatoryCA: exports.store.controlDialog.isMandatoryCA, isExclusiveCA: exports.store.controlDialog.isExclusiveCA, recurrence: exports.store.controlDialog.recurrence, comments: exports.store.controlDialog.comments, relations: exports.store.controlDialog.relations, causality_relations: exports.store.controlDialog.causality_relations, references: exports.store.controlDialog.references, entries: exports.store.controlDialog.entries, controlCosts: exports.store.controlDialog.controlCosts, availableRiskTargets: exports.store.controlDialog.availableRiskTargets, availableStatuses: exports.store.controlDialog.availableStatuses, availableOwners: exports.store.controlDialog.availableOwners, availableRecurrence: exports.store.controlDialog.availableRecurrence, udf_types: exports.store.controlDialog.udf_types }),
            React.createElement(attachedControls_1.AttachedControlList, { controls: exports.store.controls.controls })));
    };
    RiskControlApp = __decorate([
        mobx_react_1.observer
    ], RiskControlApp);
    return RiskControlApp;
}(React.Component));
exports.RiskControlApp = RiskControlApp;
var ObservationsListApp = (function (_super) {
    __extends(ObservationsListApp, _super);
    function ObservationsListApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ObservationsListApp.prototype.render = function () {
        return React.createElement(observationsList_1.default, null);
    };
    ObservationsListApp = __decorate([
        mobx_react_1.observer
    ], ObservationsListApp);
    return ObservationsListApp;
}(React.Component));
exports.ObservationsListApp = ObservationsListApp;
var RiskListApp = (function (_super) {
    __extends(RiskListApp, _super);
    function RiskListApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskListApp.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(riskCausalityList_1.default, null)));
    };
    RiskListApp = __decorate([
        mobx_react_1.observer
    ], RiskListApp);
    return RiskListApp;
}(React.Component));
exports.RiskListApp = RiskListApp;
var ControlActionApp = (function (_super) {
    __extends(ControlActionApp, _super);
    function ControlActionApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlActionApp.prototype.render = function () {
        return React.createElement(controlActionList_1.default, null);
    };
    ControlActionApp = __decorate([
        mobx_react_1.observer
    ], ControlActionApp);
    return ControlActionApp;
}(React.Component));
exports.ControlActionApp = ControlActionApp;
function prepareOverviewFilter() {
    var rewrittenFilter = {};
    var riskFilter = $("#risk_filter").closest("form").serializeArray();
    riskFilter.forEach(function (filter) {
        if (filter.name == "text_search") {
            rewrittenFilter["text_search"] = filter.value;
        }
        if (filter.name == "filter_status") {
            rewrittenFilter[filter.name] = rewrittenFilter[filter.name] || [];
            rewrittenFilter[filter.name].push(parseInt(filter.value));
        }
        if (filter.name == "owners") {
            if (filter.value != "none") {
                rewrittenFilter[filter.name] =
                    rewrittenFilter[filter.name] || [];
                rewrittenFilter[filter.name].push(parseInt(filter.value));
            }
        }
        if (filter.name == "tags") {
            if (filter.value != "none") {
                rewrittenFilter[filter.name] =
                    rewrittenFilter[filter.name] || [];
                rewrittenFilter[filter.name].push(parseInt(filter.value));
            }
        }
        if (filter.name == "confidentiality") {
            if (filter.value == "conf") {
                rewrittenFilter[filter.name] =
                    rewrittenFilter[filter.name] || [];
                rewrittenFilter[filter.name].push(filter.value);
            }
            if (filter.value == "nonconf") {
                rewrittenFilter[filter.name] =
                    rewrittenFilter[filter.name] || [];
                rewrittenFilter[filter.name].push(filter.value);
            }
        }
        if (filter.name == "reviewed_by") {
            if (filter.value != "none") {
                rewrittenFilter[filter.name] =
                    rewrittenFilter[filter.name] || [];
                rewrittenFilter[filter.name].push(parseInt(filter.value));
            }
            else {
                rewrittenFilter[filter.name] =
                    rewrittenFilter[filter.name] || [];
                rewrittenFilter[filter.name].push(null);
            }
        }
        if (filter.name == "reviewed_after") {
            rewrittenFilter[filter.name] = filter.value;
        }
        if (filter.name == "reviewed_before") {
            rewrittenFilter[filter.name] = filter.value;
        }
    });
    return rewrittenFilter;
}
exports.prepareOverviewFilter = prepareOverviewFilter;
function overViewContextFetchWithFilter() {
    return __awaiter(this, void 0, void 0, function () {
        var projectgroup_id, rewrittenFilter, overviewTabIndex, all_tabs, tabIndex;
        return __generator(this, function (_a) {
            exports.store.overview.startLoading();
            jQuery("#overview-filter-spinner").show();
            projectgroup_id = $("#filter_project").val();
            exports.store.context.set(new contexts_1.OverviewContext(projectgroup_id));
            rewrittenFilter = prepareOverviewFilter();
            overviewTabIndex = $("#overviewTabIndex").val();
            all_tabs = [
                "statusTab",
                "barplotTab",
                "valueatriskTab",
                "ownershipTab",
                "tagsTab",
                "matrixTab",
            ];
            if (has_simulation) {
                all_tabs.push("simulationTab");
            }
            tabIndex = all_tabs.splice(overviewTabIndex, 1)[0];
            return [2, exports.store.overview[tabIndex]
                    .fetchData({
                    filter: rewrittenFilter,
                    project_group: projectgroup_id,
                })
                    .then(function () {
                    return Promise.all(all_tabs.map(function (tab) {
                        return exports.store.overview[tab].fetchData({
                            filter: rewrittenFilter,
                            project_group: projectgroup_id,
                        });
                    })).then(function () {
                        jQuery("#overview-filter-spinner").hide();
                    });
                })
                    .catch(function () {
                    jQuery("#overview-filter-spinner").hide();
                })];
        });
    });
}
var LoadingSpinner = (function (_super) {
    __extends(LoadingSpinner, _super);
    function LoadingSpinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingSpinner.prototype.render = function () {
        if (this.props.loading) {
            return (React.createElement("div", { className: this.props.className },
                React.createElement("div", { className: "load-wrapper" },
                    React.createElement("div", null,
                        React.createElement("i", { className: "fas fa-spinner fa-spin fa-".concat(this.props.size, "x") })))));
        }
        else {
            return React.createElement("div", null, this.props.children);
        }
    };
    LoadingSpinner = __decorate([
        mobx_react_1.observer
    ], LoadingSpinner);
    return LoadingSpinner;
}(React.Component));
exports.LoadingSpinner = LoadingSpinner;
var SharedOverviewComponents = (function (_super) {
    __extends(SharedOverviewComponents, _super);
    function SharedOverviewComponents() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SharedOverviewComponents.prototype.render = function () {
        return (React.createElement("div", { className: "SharedOverviewApps" },
            React.createElement(editableListDialog_1.EditableListDialog, __assign({ isOpen: exports.store.editableListDialog.isOpen, isReady: exports.store.editableListDialog.isReady, dialogHeader: exports.store.editableListDialog.dialogHeader, onDialogClose: exports.store.editableListDialog.closeDialog.bind(exports.store.editableListDialog) }, exports.store.editableListDialog.listProps))));
    };
    SharedOverviewComponents = __decorate([
        mobx_react_1.observer
    ], SharedOverviewComponents);
    return SharedOverviewComponents;
}(React.Component));
exports.SharedOverviewComponents = SharedOverviewComponents;
function draw_risk_page(project_id, risk_id) {
    exports.store.context.set(new contexts_1.RiskContext(project_id, parseInt(risk_id)));
    var causes_container = document.getElementById("id_causes");
    if (causes_container) {
        (0, react_dom_1.render)(React.createElement(RiskCausesApp, null), causes_container);
    }
    var effects_container = document.getElementById("id_effects");
    if (effects_container) {
        (0, react_dom_1.render)(React.createElement(RiskEffectsApp, null), effects_container);
    }
    var references_container = document.getElementById("id_references");
    if (references_container) {
        exports.store.riskPage.accordion.fetchReferences();
        (0, react_dom_1.render)(React.createElement(RiskReferencesApp, null), references_container);
    }
    if (causes_container || effects_container) {
        exports.store.riskPage.accordion.fetchCausalities();
    }
}
exports.draw_risk_page = draw_risk_page;
$(document).ready(function () {
    var container;
    var project_id = $("#project_id").val();
    var is_project_admin = $("#is_project_admin").val() === "True";
    var risk_id = $("#risk_id").val();
    if (project_id && risk_id) {
        draw_risk_page(project_id, risk_id);
        document.addEventListener("htmx:afterSettle", function () {
            draw_risk_page(project_id, risk_id);
        });
        var review_container = document.getElementById("risk-review");
        if (review_container) {
            exports.store.riskPage.riskReview.fetchRiskReview();
            exports.store.riskPage.riskReview.fetchPermission();
            (0, react_dom_1.render)(React.createElement(riskReviewPanelApp_1.RiskReviewPanelApp, null), review_container);
        }
    }
    container = document.getElementById("risk_page_control_list");
    if (container) {
        exports.store.context.set(new contexts_1.RiskContext(project_id, parseInt(risk_id)));
        (0, react_dom_1.render)(React.createElement(RiskControlApp, null), container);
        exports.store.controls.fetchControls();
    }
    container = document.getElementById("risk_page_maps");
    if (container) {
        (0, react_dom_1.render)(React.createElement(RiskBimMaps_1.default, { project_id: project_id, type_id: risk_id, type: 'risk' }), container);
    }
    container = document.getElementById("risk_list_react_container");
    if (container) {
        exports.store.context.set(new contexts_1.ProjectContext(project_id));
        exports.store.users.fetchUsers();
        exports.store.risklist.fetchData(window.location.search).then(function () {
            exports.store.risklist.filter.fetchData();
            exports.store.risklist.settings.fetchData();
            exports.store.risklist.bulkMenu.fetchData();
        });
        exports.store.causalitylist.causes
            .fetchData(window.location.search)
            .then(function () {
            exports.store.causalitylist.causes.filter.fetchData();
            exports.store.causalitylist.causes.settings.fetchData();
        });
        exports.store.causalitylist.effects
            .fetchData(window.location.search)
            .then(function () {
            exports.store.causalitylist.effects.filter.fetchData();
            exports.store.causalitylist.effects.settings.fetchData();
        });
        exports.store.causalitylist.bulkMenu.fetchData();
        (0, react_dom_1.render)(React.createElement(RiskListApp, null), container);
    }
    (0, dataListLoader_1.render_data_list)("observations_list_react_container", project_id, ObservationsListApp, exports.store.observationslist);
    container = document.getElementById("logistics_app_react_container");
    if (container) {
        (0, react_dom_1.render)(React.createElement(LogisticsApp_1.LogisticsApp, { project_id: project_id, is_project_admin: is_project_admin }), container);
    }
    container = document.getElementById("site_maps_react_container");
    container &&
        (0, react_dom_1.render)(React.createElement(AdminAppWrapper_1.AdminAppWrapper, { element: container.closest(".tab-pane") },
            React.createElement(SiteMapsAdminApp_1.SiteMapsAdminApp, { project_id: project_id })), container);
    container = document.getElementById("control_action_list_react_container");
    if (container) {
        exports.store.getMe();
        exports.store.context.set(new contexts_1.ProjectContext(project_id));
        exports.store.users.fetchUsers();
        exports.store.controllist.filter.fetchData();
        exports.store.controllist.fetchData(window.location.search);
        exports.store.controllist.settings.fetchData();
        exports.store.controllist.bulkMenu.fetchData();
        exports.store.actionlist.filter.fetchData();
        exports.store.actionlist.fetchData(window.location.search);
        exports.store.actionlist.settings.fetchData();
        exports.store.actionlist.bulkMenu.fetchData();
        (0, react_dom_1.render)(React.createElement(ControlActionApp, null), container);
        exports.store.roles.fetchRoles().then(function () {
            for (var i = 0; i < exports.store.roles.roles.length; i++) {
                var role = exports.store.roles.roles[i];
                if (role.user == exports.store.getMe().id && role.role == 10) {
                    exports.store.isProjectAdmin.set(true);
                    break;
                }
            }
        });
    }
    container = document.getElementById("reponsibility_react_container");
    if (container) {
        if (project_id) {
            exports.store.context.set(new contexts_1.ProjectContext(project_id));
        }
        exports.store.responsibility.filter.fetchData(window.location.search);
        exports.store.responsibility.data.fetchData(window.location.search);
        (0, react_dom_1.render)(React.createElement(responsibilities_1.ResponsibilitiesApp, null), container);
    }
    container = document.getElementById("shared_overview_react_component_anchor");
    var filterEventHandler = function (e) {
        var project_group_id = $("#filter_project").val();
        window.history.pushState(null, null, window.location.pathname + "?project_group=" + project_group_id);
        $("div#filter").find("#submit_project_filter").click();
        overViewContextFetchWithFilter();
    };
    if (container) {
        var filterButton = $("#submit_project_filter2");
        filterButton.off("click");
        filterButton.on("click", filterEventHandler);
        $("#filter_project").on("change", filterEventHandler);
        $("#filter").on("submit", function (e) {
            e.preventDefault();
            overViewContextFetchWithFilter();
        });
        overViewContextFetchWithFilter();
        exports.store.overview.viewOptions.fetchOptionsContext();
        (0, react_dom_1.render)(React.createElement(SharedOverviewComponents, null), container);
        (0, react_dom_1.render)(React.createElement(viewOptions_1.ViewOptionsApp, null), document.getElementById("view_options_app_anchor"));
        (0, react_dom_1.render)(React.createElement(overviewApp_1.OverviewApp, { hasSimulation: has_simulation }), document.getElementById("overview_app_anchor"));
    }
    container = document.getElementById("react-governance");
    if (container) {
        var contract = parseInt(/contracts\/(\d+)/g.exec(window.location.href)[1]);
        exports.store.context.set(new contexts_1.ContractContext(contract));
        (0, react_dom_1.render)(React.createElement(ContractGovernanceApp, null), container);
    }
    container = document.getElementById("edit_project_remapping_app");
    if (container) {
        exports.store.context.set(new contexts_1.RemappingContext(project_id, 0));
        exports.store.users.fetchUsers().then(function () {
            (0, react_dom_1.render)(React.createElement(remappingApp_1.RemappingApp, { project_id: project_id }), container);
        });
    }
    var container_project_form = document.getElementById("edit_project_info");
    if (container_project_form) {
        (0, react_dom_1.render)(React.createElement(projectForm_1.default, { project_id: project_id }), container_project_form);
    }
    var container_categories = document.getElementById("edit_project_categories");
    if (container_categories) {
        var project_id_1 = $("#project_id").val();
        (0, react_dom_1.render)(React.createElement(editCategories_1.default, { project_id: project_id_1 }), container_categories);
    }
    var container_risk_targets = document.getElementById("edit_project_risk_targets");
    if (container_risk_targets) {
        (0, react_dom_1.render)(React.createElement(editRiskTargets_1.default, { project_id: project_id }), container_risk_targets);
    }
    var container_ifc_export = document.getElementById("react-ifc-export");
    if (container_ifc_export) {
        (0, react_dom_1.render)(React.createElement(ifcExport_1.IFCExportApp, { project_id: project_id }), container_ifc_export);
    }
});
